var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamPassExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7737_5524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4999 13.8C5.56361 13.8 6.6169 14.0096 7.59964 14.4166C8.58237 14.8237 9.47531 15.4203 10.2275 16.1725C10.9796 16.9246 11.5763 17.8176 11.9833 18.8003C12.3904 19.7831 12.5999 20.8363 12.5999 21.9L4.4999 21.9V13.8Z",
    fill: "#FF7575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 23H18C18.7956 23 19.5587 22.6839 20.1213 22.1213C20.6839 21.5587 21 20.7956 21 20V4C21 3.20435 20.6839 2.44129 20.1213 1.87868C19.5587 1.31607 18.7956 1 18 1H15C14.7348 1 14.4804 1.10536 14.2929 1.29289C14.1054 1.48043 14 1.73478 14 2C14 2.53043 13.7893 3.03914 13.4142 3.41421C13.0391 3.78929 12.5304 4 12 4C11.4696 4 10.9609 3.78929 10.5858 3.41421C10.2107 3.03914 10 2.53043 10 2C10 1.73478 9.89464 1.48043 9.70711 1.29289C9.51957 1.10536 9.26522 1 9 1H6C5.20435 1 4.44129 1.31607 3.87868 1.87868C3.31607 2.44129 3 3.20435 3 4V20C3 20.7956 3.31607 21.5587 3.87868 22.1213C4.44129 22.6839 5.20435 23 6 23ZM5 10H5.882C6.14722 10 6.40157 9.89464 6.58911 9.70711C6.77664 9.51957 6.882 9.26522 6.882 9C6.882 8.73478 6.77664 8.48043 6.58911 8.29289C6.40157 8.10536 6.14722 8 5.882 8H5V4C5 3.73478 5.10536 3.48043 5.29289 3.29289C5.48043 3.10536 5.73478 3 6 3H8.126C8.347 3.85953 8.84756 4.62115 9.5489 5.16498C10.2502 5.7088 11.1125 6.00395 12 6.00395C12.8875 6.00395 13.7498 5.7088 14.4511 5.16498C15.1524 4.62115 15.653 3.85953 15.874 3H18C18.2652 3 18.5196 3.10536 18.7071 3.29289C18.8946 3.48043 19 3.73478 19 4V8H18.118C17.8528 8 17.5984 8.10536 17.4109 8.29289C17.2234 8.48043 17.118 8.73478 17.118 9C17.118 9.26522 17.2234 9.51957 17.4109 9.70711C17.5984 9.89464 17.8528 10 18.118 10H19V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20V10ZM7.706 9C7.706 8.73478 7.81136 8.48043 7.99889 8.29289C8.18643 8.10536 8.44078 8 8.706 8H10.588C10.8532 8 11.1076 8.10536 11.2951 8.29289C11.4826 8.48043 11.588 8.73478 11.588 9C11.588 9.26522 11.4826 9.51957 11.2951 9.70711C11.1076 9.89464 10.8532 10 10.588 10H8.706C8.44078 10 8.18643 9.89464 7.99889 9.70711C7.81136 9.51957 7.706 9.26522 7.706 9ZM12.412 9C12.412 8.73478 12.5174 8.48043 12.7049 8.29289C12.8924 8.10536 13.1468 8 13.412 8H15.294C15.5592 8 15.8136 8.10536 16.0011 8.29289C16.1886 8.48043 16.294 8.73478 16.294 9C16.294 9.26522 16.1886 9.51957 16.0011 9.70711C15.8136 9.89464 15.5592 10 15.294 10H13.412C13.1468 10 12.8924 9.89464 12.7049 9.70711C12.5174 9.51957 12.412 9.26522 12.412 9Z",
    fill: "#7A1F1F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7737_5524)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.707107 22.7071C0.316583 22.3166 0.316583 21.6834 0.707107 21.2929L21.2929 0.707106C21.6834 0.316582 22.3166 0.316582 22.7071 0.707106C23.0976 1.09763 23.0976 1.7308 22.7071 2.12132L2.12132 22.7071C1.7308 23.0976 1.09763 23.0976 0.707107 22.7071Z",
    fill: "#7A1F1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7737_5524",
    x: -0.585693,
    y: 0.414185,
    width: 23.5857,
    height: 25.5858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.960784 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7737_5524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7737_5524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7737_5524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPassExpired);
export default __webpack_public_path__ + "static/media/team-pass-expired.d7f69c123620dd8240762ddb7e86b8d4.svg";
export { ForwardRef as ReactComponent };